import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * list of API endpoints as tokens, to be used elsewhere in application
 * @ignore in coverage
 */
export const CONNECT_DOMAIN = new InjectionToken<string>( 'CONNECT_DOMAIN', {
    providedIn: 'root',
    factory: () => environment.azure.connectDomain
} );
export const REDIRECT_URI = new InjectionToken<string>( 'REDIRECT_URI', {
    providedIn: 'root',
    factory: () => environment.azure.appRedirectUri
} );
export const CONNECT_API = new InjectionToken<string>( 'CONNECT_API', {
    providedIn: 'root',
    factory: () => environment.api.identityApi
} );
export const REGISTRAR_API = new InjectionToken<string>( 'REGISTRAR_API', {
    providedIn: 'root',
    factory: () => environment.api.registrarApi
} );
export const SCOPE_API = new InjectionToken<string>( 'SCOPE_API', {
    providedIn: 'root',
    factory: () => environment.api.scopeApi
} );
export const AGENTS_API = new InjectionToken<string>( 'AGENTS_API', {
    providedIn: 'root',
    factory: () => environment.api.agentsApi
} );
export const UNLOCODE_API = new InjectionToken<string>( 'UNLOCODE_API', {
    providedIn: 'root',
    factory: () => environment.api.unlocodeApi
} );
export const IMPOST_API = new InjectionToken<string>( 'IMPOST_API', {
    providedIn: 'root',
    factory: () => environment.api.impostApi
} );
export const EXCHANGE_API = new InjectionToken<string>( 'EXCHANGE_API', {
    providedIn: 'root',
    factory: () => environment.api.exchangeApi
} );

/**
 * KEYS used for certain api requests
 */
export const MAPTILER_KEY = new InjectionToken<string>( 'MAPTILER_KEY', {
    providedIn: 'root',
    factory: () => environment.keys.maptiler
} );
export const UNLOCODE_KEY = new InjectionToken<string>( 'UNLOCODE_KEY', {
    providedIn: 'root',
    factory: () => environment.keys.unlocode
} );
